<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              <ion-title>Add New User</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <AddNewUser />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import { add } from 'ionicons/icons';
// import CPOUserCreation from "@/components/admin/CPOUserCreation.vue";
import AddNewUser from "@/components/admin/AddNewUser.vue";
import { IonBackButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
  name:  'addNewUser',
  components: {
    AddNewUser, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, IonBackButton
  },
  data() {
    return {
      add
    }
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    addNewCPO() {
      this.$router.push("addNewCorporate"); 
    }
  }
})
</script>